import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { css } from 'styled-components'

import { WalletImport } from '@root/features/wallet/import-wallet/ui/import-wallet'
import { Drawer } from '@root/shared/ui-kit'

import { reatomWalletImportDialog } from './atoms'

export const WalletImportDrawer: React.FC = () => {
  const [open, setOpen] = useAtom(reatomWalletImportDialog)

  const { t } = useTranslation()

  return (
    <AnimatePresence>
      <Root
        open={open}
        onOpenChange={setOpen}
        title={t('wallet.import_wallet')}
      >
        <WalletImport
          device="mobile"
          onClose={() => setOpen(false)}
          css={css`
            padding-inline: 12px;
            padding-bottom: 18px;
            display: grid;
            gap: 20px;
          `}
        />
      </Root>
    </AnimatePresence>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);

  display: grid;
  grid-template-rows: minmax(0, 1fr);
`
